import { type VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';
import { badgeVariants } from '@/shared/constants/ui-variants';
import { cn } from '@/shared/lib/utils';

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
  readonly clickable?: boolean;
}

export function Badge({ className, variant, clickable, ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        badgeVariants({ variant }),
        clickable && 'cursor-pointer active:scale-95',
        className
      )}
      {...props}
    />
  );
}
